import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class TokenService {
    getToken(key: string): string | null {
        return sessionStorage.getItem(key);
    }
    setToken(key: string, token: string): void {
        sessionStorage.setItem(key, token);
    }
    clearToken(key: string): void {
        sessionStorage.removeItem(key);
    }
}
